import {topDestinationsApiConfig, __VOYAGERX__} from '../../../config/api-config';

export const prepareDestinationsApiRequest = () => {
  let url = `${__VOYAGERX__}`;
  url += `/api/${topDestinationsApiConfig.version}/hotels/get_home_page_data/`;
  return url;
};
